<template>
  <div class="main">
    <div class="main-head">
      <div class="main-info">
        <div class="main-font">
          <div class="main-info-font">机器<span style="color: #063F95">翻译</span>专家 机构服务平台</div>
          <div class="main-info-font2">
            中高等院校、科研院所、公共
            图书馆、医疗机构等用户的全
            文在线翻译平台
          </div>
          <div class="main-button">
            <span data-track-text="H5首页立即使用" aria-label="H5首页立即使用" @click="toPath('/h5/trans')">立即使用</span>
          </div>

        </div>
      </div>
    </div>
    <div class="main-top">
      <div class="main-top-head">
        为什么选择微思翻译?
      </div>
      <div class="main-top-head-info">
        <div>
          为提高行业的高效，快捷我们以精准的专业术语来协助您 在保持原文格式的情况下快速的完成文档翻译，交付于您 一份精美的使用结果。
        </div>
      </div>
    </div>
    <div class="main-select">
      <div class="main-select-item">
        <div class="main-select-item-one">
          <img src="../../assets/H5/ywpb.png" width="50" alt="">
          <span class="item-head">原文排版</span>
          <span class="item-info">译文保持与原文一致的排版格式，方便对比阅读，快速对应。</span>
        </div>
        <div class="main-select-item-two">
          <img src="../../assets/H5/ffyw.png" width="50" alt="">
          <span class="item-head">丰富译文</span>
          <span class="item-info">提供多种格式译文，创新地提出双向批注译文，实现了一篇文档双语对照阅读的需要。</span>
        </div>
      </div>
      <div class="main-select-item">
        <div class="main-select-item-one">
          <img src="../../assets/H5/plfy.png" width="50" alt="">
          <span class="item-head">批量翻译</span>
          <span class="item-info">一次拖拽多篇文档同时翻译，高效、快速。</span>
        </div>
        <div class="main-select-item-two">
          <img src="../../assets/H5/jgdz.png" width="50" alt="">
          <span class="item-head">机构定制</span>
          <span class="item-info">针对不同机构用户实现个性化定制需求，快速实现机构内部系统整合。</span>
        </div>
      </div>
      <div class="main-select-item">
        <div class="main-select-item-one">
          <img src="../../assets/H5/dzyy.png" width="50" alt="">
          <span class="item-head">多种语言</span>
          <span class="item-info">支持304种语言的自动识别与互译服务。</span>
        </div>
        <div class="main-select-item-two">
          <img src="../../assets/H5/yzjl.png" width="50" alt="">
          <span class="item-head">质优价廉</span>
          <span class="item-info">头部质量，底部价格，是您 最佳选择。</span>
        </div>
      </div>
    </div>
    <div class="main-desc">
      <div class="main-desc-tsfy">
        <div class="main-desc-tsfy-right">
          <span class="main-desc-tsfy-right-head">特色翻译</span>
          <span class="main-desc-tsfy-right-info">用户可以根据其自建词典，完成符合其专业特点的精准翻译</span>
          <div class="main-desc-tsfy-right-button">
            <span data-track-text="H5首页立即翻译" aria-label="H5首页立即翻译" @click="toPath('/h5/trans')">立即翻译</span>
          </div>
        </div>
      </div>
      <div class="main-desc-wjzh">
        <div class="main-desc-tsfy-wjzh">
          <span class="main-desc-tsfy-wjzh-head">文件转换</span>
          <span class="main-desc-tsfy-wjzh-info">为了满足用户对文档编辑的需求，我们特推出批量文档转换服务，支持快速、大量的转换操作。</span>
          <div class="main-desc-tsfy-wjzh-button">
            <span data-track-text="H5首页立即体验PDF转换" aria-label="H5首页立即体验PDF转换" @click="toPath('/h5/convert')">立即体验</span>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 74px;width: 100%;height: 160px;background: #FFFFFF;"></div>
  </div>
</template>

<script>
export default {
  name: "Main",
  methods:{
    toPath(path) {
      this.$router.push(path)
    },
  }
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  height: 2666px;
  background: #f5f5f5;
  display: flex;
  flex-flow: column;
  align-items: center;

  .main-head {
    width: 100%;
    height: 468px;
    background: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;

    .main-info {
      width: 768px;
      height: 386px;
      background: url("../../assets/H5/bac1.png") no-repeat;
      background-position: right;
      background-size: contain;
      position: absolute;

      .main-font {
        margin-left: 30px;

        .main-info-font {
          width: 445px;
          height: 35px;
          font-size: 36px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #5E6176;
          line-height: 56px;
        }

        .main-info-font2 {
          width: 312px;
          height: 96px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767D;
          line-height: 36px;
          margin-top: 43px;
        }

        .main-button {
          width: 166px;
          height: 48px;
          background: #063F95;
          border-radius: 25px 0px 25px 0px;
          margin-top: 36px;
          display: flex;
          justify-content: center;
          align-items: center;

          span {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 56px;
          }
        }
      }

    }
  }

  .main-top {
    width: 768px;

    .main-top-head {
      margin-top: 36px;
      font-size: 30px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 40px;
      text-align: center;
      background: url("../../assets/H5/head-font.png") no-repeat;
      background-size: 285px;
      background-position: center bottom;
    }

    .main-top-head-info {
      font-size: 24px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #73767D;
      line-height: 36px;
      display: flex;
      justify-content: center;
      margin-top: 30px;

      div {
        width: 598px;
        height: 95px;
      }
    }

  }

  .main-select {
    margin-top: 57px;
    width: 768px;

    .main-select-item {
      display: flex;
      margin: 0 33px;
      justify-content: space-between;
      height: 220px;
      margin-bottom: 58px;

      .main-select-item-one {
        display: flex;
        flex-flow: column;
        width: 336px;

        .item-head {
          width: 100px;
          height: 24px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          margin-top: 22px;
        }

        .item-info {
          width: 336px;
          height: 60px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767D;
          line-height: 36px;
          margin-top: 19px;
        }
      }

      .main-select-item-two {
        display: flex;
        flex-flow: column;
        width: 336px;

        .item-head {
          width: 100px;
          height: 24px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #333333;
          line-height: 40px;
          margin-top: 22px;
        }

        .item-info {
          width: 336px;
          height: 60px;
          font-size: 24px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #73767D;
          line-height: 36px;
          margin-top: 19px;
        }
      }
    }
  }

  .main-desc {
    width: 768px;

    .main-desc-tsfy {
      background: url("../../assets/H5/tsfy.png") no-repeat;
      background-position: left;
      background-size: contain;
      height: 387px;
      display: flex;
      justify-content: flex-end;

      .main-desc-tsfy-right {
        display: flex;
        flex-flow: column;
        width: 260px;
        justify-content: center;
        margin-right: 20px;

        .main-desc-tsfy-right-head {
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          background: url("../../assets/H5/head-font.png") no-repeat;
          background-size: 285px;
          background-position: center bottom;
          width: 125px;
        }

        .main-desc-tsfy-right-info {
          margin-top: 37px;
          margin-bottom: 37px;
          width: 260px;
          font-size: 24px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #73767D;
          line-height: 36px;
        }

        .main-desc-tsfy-right-button {
          width: 166px;
          height: 48px;
          background: #063F95;
          border-radius: 25px 0px 25px 0px;
          text-align: center;

          span {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 46px;
          }
        }
      }
    }
    .main-desc-wjzh {
      margin-top: 100px;
      background: url("../../assets/H5/wjzh.png") no-repeat;
      background-position: right;
      background-size: contain;
      height: 387px;
      display: flex;
      justify-content: flex-start;

      .main-desc-tsfy-wjzh {
        display: flex;
        flex-flow: column;
        width: 260px;
        justify-content: center;
        margin-left: 33px;

        .main-desc-tsfy-wjzh-head {
          font-size: 30px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 40px;
          background: url("../../assets/H5/head-font.png") no-repeat;
          background-size: 285px;
          background-position: center bottom;
          width: 125px;
        }

        .main-desc-tsfy-wjzh-info {
          margin-top: 37px;
          margin-bottom: 37px;
          width: 288px;
          font-size: 24px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #73767D;
          line-height: 36px;
        }

        .main-desc-tsfy-wjzh-button {
          width: 166px;
          height: 48px;
          background: #063F95;
          border-radius: 25px 0px 25px 0px;
          text-align: center;

          span {
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 46px;
          }
        }
      }
    }
  }
}

</style>
